/**
 * Analytics Service - Google Analytics 4 event tracking
 */

import { categories } from '../data/games';

const gtag = (...args) => {
  if (typeof window.gtag === 'function') {
    window.gtag(...args);
  }
};

/**
 * Initialize analytics with user properties.
 * Called once after auth state resolves on page load.
 */
export const initAnalytics = (isLoggedIn, userId) => {
  gtag('set', 'user_properties', {
    is_logged_in: isLoggedIn,
  });

  if (userId) {
    gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
      user_id: userId,
    });
  }

  gtag('event', 'page_load', {
    is_logged_in: isLoggedIn,
    user_id: userId || null,
  });
};

/**
 * Track a game link click.
 *
 * `isFavorite` is passed in rather than looked up: favorites are server state
 * now (D22), and this module has no business fetching them.
 */
export const trackGameLinkClick = (game, isFavorite = false) => {
  const category = categories.find(c => c.id === game.category);

  gtag('event', 'game_link_click', {
    game_id: game.id,
    game_name: game.name,
    game_category: category?.label || 'Unknown',
    is_favorite: isFavorite,
  });
};

/**
 * Track a share action. `method` is which button was used: 'copy', 'native'
 * (the OS share sheet) or a platform id like 'x' or 'whatsapp'. Recorded on the
 * press, not on completion - none of these hand back whether the person
 * actually went through with it.
 *
 * Uses GA4's recommended `share` event so it shows up in the standard reports.
 */
export const trackShare = (method) => {
  gtag('event', 'share', {
    method,
    content_type: 'daily_scores',
  });
};

/**
 * Track viewing the friends page.
 */
export const trackViewFriends = (gamesPlayedTodayCount) => {
  gtag('event', 'view_friends', {
    games_played_today_count: gamesPlayedTodayCount,
  });
};
